import { bodyCopyLink, Input } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styled from 'styled-components';
import Constants from '../../constants';
import { Col3Col9 } from '../common';
import { ToastType } from './ToastType';

export const InputLink = styled.a`
	display: block;
	font-size: 12px !important;
	width: fit-content;
	margin-top: 5px;
	${bodyCopyLink};
`;
InputLink.displayName = 'InputLink';

export interface ISurveyLinkProps {
	surveyLinkId?: string;
	toast: (type: ToastType, message: string) => any;
	labelSize?: 'sm' | 'md' | 'lg';
	isMultiLanguageSurvey?: boolean;
}

export class SurveyLink extends React.Component<
	ISurveyLinkProps,
	{
		surveyLinkDisabled: boolean;
	}
> {
	private surveyLinkRef: any;

	constructor(props: ISurveyLinkProps) {
		super(props);

		this.state = {
			surveyLinkDisabled: true,
		};

		this.copyLink = this.copyLink.bind(this);
		this.getLink = this.getLink.bind(this);

		this.surveyLinkRef = React.createRef();
	}

	public render() {
		const { surveyLinkDisabled } = this.state;

		return (
			<>
				<Col3Col9 label='Survey Link' labelSize={this.props.labelSize} className='tws-distribution-survey-link'>
					<Input
						ref={this.surveyLinkRef}
						value={this.getLink()}
						maxLength={150}
						placeholder={'URLofTheSurveyLink.com'}
						readonly={surveyLinkDisabled}
					/>
					{<InputLink onClick={this.copyLink}>Copy Link</InputLink>}
				</Col3Col9>
			</>
		);
	}

	public getLink() {
		const { surveyLinkId, isMultiLanguageSurvey } = this.props;
		if (!isMultiLanguageSurvey) {
			return `${Constants.MRESEARCH_SURVEY_ENGINE_BASE_URL}Default.aspx?eaid=${surveyLinkId}`;
		} else {
			return `${Constants.MRESEARCH_SURVEY_ENGINE_BASE_URL}SelectLanguage.aspx?eaid=${surveyLinkId}`;
		}
	}

	private copyLink() {
		this.setState({ surveyLinkDisabled: false }, () => {
			// See https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
			// eslint-disable-next-line react/no-find-dom-node
			const surveyLinkInput = ReactDOM.findDOMNode(this.surveyLinkRef.current) as HTMLInputElement;
			if (surveyLinkInput) {
				const input = surveyLinkInput.querySelector('input');
				if (input) {
					input.focus();
					input.select();
					document.execCommand('copy');
					input.blur();
				}
			}
			this.setState({ surveyLinkDisabled: true });
		});

		const { toast } = this.props;
		if (toast) {
			toast(ToastType.Info, 'Link copied to clipboard');
		}
	}
}
